<div class="layoutBlock detailpage">
    <div class="entrypageSideLeft">
        <div style="float: right;">
            <div class="circle-icon">
                <div>
                    <img hisImage="table" class="inlineicon" title="{{'rm.erp.jobapplication.header' | hisUi}}">
                </div>
            </div>
        </div>
    </div>
    <div class="entrypageCenter">
        <div class="vcard">
            <h1>
                {{'rm.erp.jobapplication.applyfor' | hisUi}}
                <br><br>
                {{jobAdvertisement.shortDescription}}
            </h1>
        </div>

        <erp-jobapplication-form *ngIf="activeComponent === JOBAPPLICATION_COMPONENT_IDENT.form"
            [jobApplication]="jobApplication" (onJobApplicationCreated)="jobApplicationCreated($event)"
            (valueChange)="onModelChange($event)" (onDeleteJobApplication)="deleteJobApplication($event)">
        </erp-jobapplication-form>
        <erp-jobapplication-overview *ngIf="activeComponent === JOBAPPLICATION_COMPONENT_IDENT.overview"
            [jobApplication]="jobApplication" (onJobApplicationSent)="jobApplicationSent($event)"
            (onBackToJobApplicationForm)="backToJobApplicationForm($event)">
        </erp-jobapplication-overview>
        <erp-jobapplication-success *ngIf="activeComponent === JOBAPPLICATION_COMPONENT_IDENT.success"
            [jobApplicationDto]="jobApplicationDto">
        </erp-jobapplication-success>

    </div>
    <div class="entrypageSideRight">
        <p-panel header="{{'rm.erp.jobapplication.information' | hisUi}}">
            <div>
                <div class="furtherInformations">
                    <small>
                        <span>{{ jobAdvertisement.jobAdvertisementCategory?.longtext }}</span>
                    </small>
                </div>
                <a routerLink="/jobadvertisement/view/{{jobAdvertisement.id}}" target="_blank" hisImage="book"
                    class="transparent">{{jobAdvertisement.shortDescription}}</a>
                <br><br>
                <span *ngIf="jobAdvertisement.refNumber && isRefNumberVisible">
                    {{'rm.erp.jobadvertisement.refnumber' | hisUi}}: {{jobAdvertisement.refNumber}}<br>
                </span>
                <span *ngIf="jobAdvertisement.validTo && isValidToVisible">
                    {{'rm.erp.jobadvertisement.validto' | hisUi}}: {{jobAdvertisement.validTo | hisDate }}<br>
                </span>
            </div>
        </p-panel>
        <br>
        <p-panel *ngIf="jobAdvertisement.firstContactPerson"
            header="{{jobAdvertisement.firstContactPerson.description}}">
            <span *ngIf="jobAdvertisement.firstContactPerson.firstname && jobAdvertisement.firstContactPerson.lastname">
                {{jobAdvertisement.firstContactPerson.salutation}} {{jobAdvertisement.firstContactPerson.firstname}}
                {{jobAdvertisement.firstContactPerson.lastname}}
            </span>
            <br><br>
            <his-display-phone *ngIf="jobAdvertisement.firstContactPerson.phone"
                value="{{jobAdvertisement.firstContactPerson.phone}}"></his-display-phone>
            <br>
            <his-display-email *ngIf="jobAdvertisement.firstContactPerson.mail"
                value="{{jobAdvertisement.firstContactPerson.mail}}"></his-display-email>
        </p-panel>
        <br *ngIf="jobAdvertisement.firstContactPerson">
        <p-panel *ngIf="jobAdvertisement.secondContactPerson"
            header="{{jobAdvertisement.secondContactPerson.description}}">
            <span
                *ngIf="jobAdvertisement.secondContactPerson.firstname && jobAdvertisement.secondContactPerson.lastname">
                {{jobAdvertisement.secondContactPerson.salutation}} {{jobAdvertisement.secondContactPerson.firstname}}
                {{jobAdvertisement.secondContactPerson.lastname}}
            </span>
            <br><br>
            <his-display-phone *ngIf="jobAdvertisement.secondContactPerson.phone"
                value="{{jobAdvertisement.secondContactPerson.phone}}"></his-display-phone>
            <br>
            <his-display-email *ngIf="jobAdvertisement.secondContactPerson.mail"
                value="{{jobAdvertisement.secondContactPerson.mail}}"></his-display-email>
        </p-panel>
        <br *ngIf="jobAdvertisement.secondContactPerson">

        <p-panel *ngIf="activeComponent === JOBAPPLICATION_COMPONENT_IDENT.form" header="{{'rm.erp.jobapplication.loadsave' | hisUi}}">
            <div class="layoutBlock">
                <span (click)="localSave()" (keypress)="localSave()" [style]="{'margin-right': '6px'}" class="p-element p-button p-component p-fileupload-choose">
                    <span class="p-button-label ng-star-inserted">{{'rm.erp.jobapplication.loadsave.button.save' | hisUi}}
                    </span>
                    <input type="file" accept=".json" class="ng-star-inserted">
                </span>
                <p-fileUpload #loadJobApplicationData mode="basic" [auto]="true"
                    chooseLabel="{{'rm.erp.jobapplication.loadsave.button.load' | hisUi}}" chooseIcon=""
                    [customUpload]="true" (uploadHandler)="localLoad($event, loadJobApplicationData)" [fileLimit]="1"
                    [maxFileSize]="50000" accept=".json">
                </p-fileUpload>
            </div>
        </p-panel>
        <br *ngIf="activeComponent === JOBAPPLICATION_COMPONENT_IDENT.form">
    </div>
</div>
